import React from 'react';
import {RUTA_IMAGEN} from '../../../../utils/rutasFijas';

const Imagenes = (props) => {

  let imagenes = [];
  if (props.imagenes)
    imagenes = props.imagenes;

  return (
          <div className="misReservasImagen col-xl-1 col-lg-1 col-md-2 col-sm-12 col-12">
              {imagenes.length > 0
                ? <img className="d-block m-auto" src={RUTA_IMAGEN + 'destinos/bg/' + imagenes[0]} alt="Imagen del destino seleccionado" height="150" />
                : <span style={{fontSize: '150px', width: '100%'}} className="material-icons">night_shelter</span>
              }
          </div>
        )
}

export default Imagenes



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/Imagen.js